import { FormActionsBase } from './base';
import { WithGender } from './with-gender';

/**
 * При добавлении новых алгоритмов вставлять их тут
 * для экспорта и типизации в пропс компонента
 */
export const actions = { Base: FormActionsBase, WithGender };
